import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
/* import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateCalendarField from '../../../components/DateCalendar/DateCalendarField';
import DateFnsUtils from '@date-io/date-fns';
import { enGB, pt } from 'date-fns/locale' */
import IconButton from '@material-ui/core/IconButton';

import DateRangeIcon from '@material-ui/icons/DateRange';
//CSS, STYLES & MEDIA ASSETS
import './BoardAccordion.scss';
import variables from '../../../assets/bootstrap/scss/_variables.scss';

//type OnChangeFnType = (instance: any) => void;
interface BoardAccordionProps {
  title?: string;
  filterMore?: any;
  hidden: boolean;
}

//Scss variable
const noRecords = variables.noRecords;
const { gridBreakLg, gridBreakMd, gridBreakSm } = variables;

const useStyles = makeStyles((theme) => ({
  root: {
    '&.MuiExpansionPanel-root': {
      background: 'none',
      boxShadow: 'none',
      '&:before': {
        background: 'none'
      }
    },
    '&.MuiExpansionPanelSummary-root': {
      borderBottomColor: noRecords,
      borderBottomWidth: 1,
      borderBottom: 'solid',
      flexDirection: 'row-reverse',
      padding: 0
    },
    '&.MuiExpansionPanelSummary-root .MuiExpansionPanelSummary-content': {
      display: 'flex'
    },
    '&.MuiExpansionPanelDetails-root': {
      paddingTop: 8,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 24
    },
    '&.MuiFormControl-root': {
      width: 150,
      marginTop: 4
    },
    '&.MuiFormControl-root .MuiInputBase-root': {
      paddingLeft: 15
    }
  },
  titleEpSummary: {
    marginLeft: 30
  },
  h5: {
    fontFamily: 'Nunito',
    letterSpacing: 1
  },
  expandIcon: {
    color: '#494949'
  },
  subtitle2: {
    fontSize: 12
  }
}));

const BoardAccordion: FunctionComponent<BoardAccordionProps> = ({
  title,
  children,
  filterMore,
  //filterMobileButton,
  hidden
  /* onChangeFrom,
    onChangeTo,
    filterDateFrom,
    filterDateTo */
}) => {
  //const { t } = useTranslation();
  const classes = useStyles();
  const [width, setWidth] = useState(0);
  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
  };

  //var language = localStorage.getItem("i18nextLng") || "pt";
  useEffect(() => {
    updateWindowDimensions();
  });

  return (
    <>
      <ExpansionPanel className={classes.root} hidden={hidden} defaultExpanded={true}>
        <ExpansionPanelSummary
          className={`${classes.root}`}
          expandIcon={<ExpandMoreIcon fontSize='large' className={classes.root} />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          <Typography
            variant='h5'
            className={`${classes.titleEpSummary} ${classes.h5} ${
              width < parseInt(gridBreakSm) ? 'font-size-16-px ml-4' : ''
            } ${
              width < parseInt(gridBreakLg) && width >= parseInt(gridBreakMd)
                ? 'font-size-20-px'
                : ''
            } my-auto text-uppercase w-100`}
          >
            {title}
          </Typography>
          {/*                     <IconButton size="small" className="d-flex d-md-none" onClick={filterMobileButton}>
                        {width > parseInt(gridBreakSm) ? <DateRangeIcon fontSize="large"></DateRangeIcon> : <DateRangeIcon fontSize="default"></DateRangeIcon>}
                    </IconButton> */}

          {/* <div className="d-md-flex pr-4 d-none" onClick={(e) => e.stopPropagation()}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={language === "PT" ? pt : enGB}>
                            <Typography variant="subtitle2" className={`${classes.subtitle2} my-auto text-right pr-3 white-space-nowrap`}>
                                {t('WoundsFilter.From')}
                            </Typography>
                            <DateCalendarField
                                id='DateFrom2'
                                fullWidth={false}
                                class={classes.root}
                                inputLabelProps={{ shrink: true }}
                                valueInput={filterDateFrom}
                                onChangeInput={onChangeFrom}
                                invalidDateMessage={t('invalidDateFormat')}

                            />
                            <Typography variant="subtitle2" className={`${classes.subtitle2} my-auto text-right pr-3 white-space-nowrap pl-5 pl-md-4 pl-lg-5`}>
                                {t('WoundsFilter.To')}
                            </Typography>
                            <DateCalendarField
                                id='DateTo2'
                                fullWidth={true}
                                class={classes.root}
                                valueInput={filterDateTo}
                                inputLabelProps={{ shrink: true }}
                                onChangeInput={onChangeTo}
                                minDate={filterDateFrom}
                                invalidDateMessage={t('invalidDateFormat')}
                            />
                        </MuiPickersUtilsProvider>
                    </div> */}
          {filterMore}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={`${classes.root} pb-0`}>
          <div className='w-100'>{children}</div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  );
};

export default BoardAccordion;
